<template>
  <header class="bg-brand-yellow w-full relative z-10">
    <div class>
      <div class="flex justify-center content-center px-4 py-4">
        <a href="/index.html">
          <img
            class="h-32"
            src="../assets/img/schlosserei-raichle-logo.svg"
            alt="Schlosserei Raichle Logo"
          />
        </a>
      </div>

      <button
        id="toggle-menu-btn"
        v-on:click="mobileMenuVisible = !mobileMenuVisible"
        type="button"
        class="sm:hidden flex justify-center content-center w-full items-center text-brand-blue font-semibold bg-white py-3"
      >
        <svg class="h-4 w-4 fill-current mx-2" viewBox="0 0 24 24">
          <path
            v-if="mobileMenuVisible"
            fill-rule="evenodd"
            d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
          />
          <path
            v-else
            fill-rule="evenodd"
            d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
          />
        </svg>
        Menü
      </button>

      <div
        id="menu"
        v-bind:class="{ hidden: !mobileMenuVisible }"
        class="px-2 py-2 bg-white sm:flex sm:justify-center sm:block sm:items-center shadow"
      >
        <a
          href="/index.html#start"
          class="block px-1 py-1 text-brand-blue sm:px-2 sm:mx-1 hover:bg-gray-100 rounded"
        >Start</a>
        <a
          href="/index.html#konfigurator"
          class="block px-1 py-1 text-brand-blue sm:px-2 sm:mx-1 hover:bg-gray-100 rounded"
        >Balkongeländer Konfigurator</a>
        <a
          href="/index.html#neuigkeiten"
          class="block px-1 py-1 text-brand-blue sm:px-2 sm:mx-1 hover:bg-gray-100 rounded"
        >Neuigkeiten</a>
        <a
          href="/projekte.html"
          class="block px-1 py-1 text-brand-blue sm:px-2 sm:mx-1 hover:bg-gray-100 rounded"
        >Projekte</a>
        <a
          href="/produkte/"
          class="block px-1 py-1 text-brand-blue sm:px-2 sm:mx-1 hover:bg-gray-100 rounded"
        >Produkte</a>
        <a
          href="/index.html#ueberuns"
          class="block px-1 py-1 text-brand-blue sm:px-2 sm:mx-1 hover:bg-gray-100 rounded"
        >Über uns</a>
        <a
          href="/index.html#kontakt"
          class="block px-1 py-1 text-brand-blue sm:px-2 sm:mx-1 hover:bg-gray-100 rounded"
        >Kontakt</a>
        <a
          href="/jobs.html"
          class="block px-1 py-1 text-brand-blue sm:px-2 sm:mx-1 hover:bg-gray-100 rounded"
        >Jobs</a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      mobileMenuVisible: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
